<mat-progress-spinner
  color="accent"
  mode="indeterminate"
></mat-progress-spinner>
